import { Component, Input, isDevMode, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SelectOptions } from '@cbuild/controls';
import { AuthenticationService } from '@cbuild/core';
import {
  CsValidators,
  FormStateControl,
  SiteVisitStatus,
  SITE_VISIT_STATUS_OPTIONS,
  UserType
} from '@cbuild/shared';
import { Observable } from 'rxjs';
import { CallCenterService } from '../../call-center.service';

@Component({
  selector: 'cs-create-site-visit',
  standalone: false,
  templateUrl: './create-site-visit.component.html',
  styleUrls: ['./create-site-visit.component.scss']
})
export class CreateSiteVisitComponent extends FormStateControl
  implements OnInit {
  @Input()
  public form: FormGroup;

  public userOptions$: Observable<SelectOptions>;
  public userType = this.authenticationService.getUser()!.type;
  public siteVisitStatusOptions: SelectOptions = SITE_VISIT_STATUS_OPTIONS;
  public todayDate: Date = new Date();

  constructor(
    private fb: FormBuilder,
    private authenticationService: AuthenticationService,
    private service: CallCenterService
  ) {
    super();
  }

  public ngOnInit(): void {
    if (isDevMode() && !this.form) {
      throw new Error('Invalid Lead or parent from');
    }
    this.userOptions$ = this.service.getSiteVisitUsers(null);
    this.updateInfoFrom();
  }

  private updateInfoFrom(): void {
    const group = this.form.get('siteVisit');
    if (!group) {
      this.infoForm = this.initializeInfoForm();
      this.form.addControl('siteVisit', this.infoForm);
    } else {
      this.infoForm = this.form.get('siteVisit') as FormGroup;
    }
  }

  private initializeInfoForm(): FormGroup {
    return this.fb.group({
      description: [''],
      startDate: [
        null,
        Validators.compose([
          CsValidators.endDateRangeValidator(this, 'remindOn')
        ])
      ],
      remindOn: [
        null,
        Validators.compose([
          CsValidators.startDateRangeValidator(this, 'startDate')
        ])
      ],
      status: [''],
      siteVisitedDate: [],
      assignTo: []
    });
  }

  public onSiteVisitStatusChange(status: SiteVisitStatus): void {
    if (status === SiteVisitStatus.NOT_VISITED) {
      this.getControl('siteVisitedDate').patchValue(null);
    }
  }

  public get canShowAssignedTo(): boolean {
    return this.userType === UserType.User.toString() ? true : false;
  }

  public get canShowSiteVisitedDateControl(): boolean {
    return this.getControl('status').value === SiteVisitStatus.VISITED;
  }
}
